import React, { useMemo } from "react";
import Heading from "@unum/heading";
import Paper from "@unum/paper";
import Clickable from "@unum/clickable";
import classnames from "classnames";
import { GridProps } from "./types";
import styles from "./Hero.module.scss";

const Grid = ({ title, asset, cards, children }: GridProps) => {
  const imageNode = useMemo(() => {
    if (!React.isValidElement<{ className: string }>(asset)) {
      return asset;
    }
    return React.cloneElement(asset, {
      className: classnames(asset.props.className, "hero__image")
    });
  }, [asset]);

  return (
    <div className={classnames(styles["Hero"], styles["Hero--grid"])}>
      <div
        className={classnames(
          styles["curve-ice-white"],
          "hero hero--curve-white hero-landing"
        )}
      >
        <div
          className={classnames(styles["image-wrapper"], "hero__image-wrapper")}
        >
          {imageNode}
        </div>
        <div className={styles["overlap-container"]}>
          <div className="spring">
            <div>
              <div className="row">
                <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                  <Heading level={1} className="hero__heading">
                    {title}
                  </Heading>
                </div>
                {children && (
                  <div className="col-xs-12 col-lg-6 col-lg-offset-3">
                    <div
                      className={classnames(
                        styles["landing-text"],
                        "hero-landing__text"
                      )}
                    >
                      {children}
                    </div>
                  </div>
                )}
              </div>
              <div className={styles["cards"]}>
                <ul className={classnames(styles["cards-list"], "row")}>
                  {cards.map(({ title, description, action, image }, index) => (
                    <li
                      key={`hero-card-${index}`}
                      className="col-xs-12 col-lg-3"
                    >
                      <Clickable {...action} className={styles["clickable"]}>
                        <Paper className={styles["card"]}>
                          {React.isValidElement<{ className: string }>(
                            image
                          ) && (
                            <div className={styles["image"]}>
                              {React.cloneElement(image, {
                                className: classnames(
                                  image.props.className,
                                  styles["image-node"]
                                )
                              })}
                            </div>
                          )}
                          <div className={styles["content"]}>
                            <div className={styles["title"]}>{title}</div>
                            <div className={styles["description"]}>
                              {description}
                            </div>
                          </div>
                        </Paper>
                      </Clickable>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grid;
